// Authenticated shell: primary navigation plus the routed page outlet.
// The full nav set is fleshed out in Task 9; research is live today.

import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';

const NAV = [
  { to: '/', label: 'Dashboard' },
  { to: '/research', label: 'Research' },
  { to: '/concepts', label: 'Concepts' },
  { to: '/prompt-review', label: 'Prompt Review' },
  { to: '/image-requests', label: 'Image Requests' },
  { to: '/assets', label: 'Assets' },
  { to: '/ingested-images', label: 'Ingested Images' },
  { to: '/artwork', label: 'Artwork' },
  { to: '/personalization', label: 'Personalization' },
  { to: '/text-layouts', label: 'Text Layouts' },
  { to: '/product-templates', label: 'Product Templates' },
  { to: '/audit', label: 'Audit' },
  { to: '/settings', label: 'Settings' },
];

export function Layout() {
  const { user, logout } = useAuth();
  return (
    <div className="app-shell">
      <header className="app-header">
        <span className="app-brand">Commerce Product Hub</span>
        <div className="app-user">
          <span>{user?.email}</span>
          <button type="button" onClick={() => void logout()}>
            Log out
          </button>
        </div>
      </header>
      <div className="app-body">
        <nav className="app-nav" aria-label="Primary">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => (isActive ? 'nav-link nav-link--active' : 'nav-link')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <main className="app-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
